"use client";

import { MotionConfig } from "framer-motion";
import { ThemeProvider as NextThemes } from "next-themes";
import type { ReactNode } from "react";

/**
 * Wraps next-themes so the theme choice persists in localStorage and drives
 * the `data-theme` attribute on <html>, which our CSS tokens key off.
 *
 * MotionConfig reducedMotion="user" makes every framer-motion animation on
 * the site honour prefers-reduced-motion (framer animations are JS-driven,
 * so the CSS reduced-motion rule alone cannot stop them).
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemes
      attribute="data-theme"
      defaultTheme="dark"
      enableSystem
      disableTransitionOnChange={false}
    >
      <MotionConfig reducedMotion="user">{children}</MotionConfig>
    </NextThemes>
  );
}
